import axios from "axios";


const baseUrl = process.env.REACT_APP_BASE_URL || "";




export const fetchGamesApi = async () => {
    const response = await axios.get(`${baseUrl}/api/games`);
    return response;
};

export const requestOtpApi = async (msisdn,ext_ref) => {
    const response = await axios.post(`${baseUrl}/api/request-otp`, { msisdn, ext_ref});
    
    return response;
};

export const verifyOtpApi = async (msisdn, referenceNo, otp ,ext_ref) => {
    const response = await axios.post(`${baseUrl}/api/verify-otp`, {
        msisdn,
        referenceNo,
        otp,
        ext_ref
    });
    return response;
    
};

export const checkUserSubscriptionApi = async (msisdn) => {
    const response = await axios.post(`${baseUrl}/login/sub`, { 
        msisdn 
    });
    return response;
};